import React, { useEffect, useState } from 'react';
import { Button } from 'antd';

function hasLeapDay(year) {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
}

function getLastFourMonths() {
    const result = [];
    const currentDate = new Date();

    for (let i = 0; i < 4; i++) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
        result.push({ year: date.getFullYear(), month: date.getMonth() + 1 });
    }

    return result.sort((a, b) => a.year - b.year || a.month - b.month);
}

const lastFourMonths = getLastFourMonths();

console.log(lastFourMonths);


const {
    d = new Date(),
    Y = d.getFullYear()
} = {};
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-indexed

const defaultYear = currentYear;
const defaultMonth = currentMonth < 10 ? `0${currentMonth}` : `${currentMonth}`;


const Datepicker25 = ({ htmlID, onSearchClick }) => {
    const [isPickerVisible, setIsPickerVisible] = useState(false);
    const [year, setYear] = useState(defaultYear);
    const [month, setMonth] = useState(defaultMonth);
    const [isShowToast, setIsShowToast] = useState(false);

    useEffect(() => {
        const H = 43;
        for (let id of [htmlID + '-bd-l', htmlID + '-bd-r']) {
            ~function ($e, isDragging = false, startY = 0, scrollTop = 0) {
                const IS_YEAR = id.includes('-bd-l');  // ✅ `-bd-l` is for year
                const IS_MONTH = id.includes('-bd-r'); // ✅ `-bd-r` is for month
    
                if (IS_YEAR) {
                    $e.scrollTop = 0;
                } else if (IS_MONTH) {
                    $e.scrollTop = 12 * H;
                }
    
                $e.addEventListener('mousedown', e => {
                    isDragging = true;
                    startY = e.clientY;
                    scrollTop = $e.scrollTop;
                    $e.style.cursor = 'grabbing';
                });
    
                $e.addEventListener('mousemove', e => {
                    if (!isDragging) return;
                    const dy = startY - e.clientY;
                    $e.scrollTop = scrollTop + dy;
                });
    
                $e.addEventListener('mouseup', () => {
                    isDragging = false;
                    $e.style.cursor = 'grab';
    
                    let curTop = $e.scrollTop;
                    let mod = curTop % H;
                    let target = mod !== 0 ? Math.round(curTop / H) * H : curTop;
                    let N = target / H;
    
                    if (typeof target === 'number') {
                        $e.scrollTop = target;
    
                        let $div = $e.getElementsByTagName('div')[N + 2];
                        if (!$div || !$div.innerText) return;
    
                        let selectedValue = $div.innerText.match(/\d+/g).join('');
    
                        if (IS_YEAR) {
                            setYear(selectedValue); // ✅ Correct year update
                        } else if (IS_MONTH) {
                            setMonth(selectedValue.padStart(2, '0')); // ✅ Correct month update
                        }
                    }
                });
            }(document.getElementById(id));
        }
    }, [htmlID]);
    
    useEffect(() => {
        const availableMonths = lastFourMonths
            .filter(item => item.year === parseInt(year))
            .map(item => item.month)
            .sort((a, b) => b - a); // Sort months in descending order
    
        if (availableMonths.length > 0) {
            let selectedMonth;
    
            if (parseInt(year) === new Date().getFullYear()) {
                // ✅ If year is the current year, select the latest month
                selectedMonth = availableMonths[0];
            } else {
                // ✅ If year is the last year, select the last available month
                selectedMonth = availableMonths[availableMonths.length - 1];
            }
    
            setMonth(selectedMonth < 10 ? `0${selectedMonth}` : `${selectedMonth}`);
    
            // Scroll to the middle after setting the new month
            setTimeout(() => {
                scrollToMiddle(htmlID + "-bd-r");
            }, 50);
        }
    }, [year]);

    const scrollToMiddle = (id) => {
        const $e = document.getElementById(id);
        if (!$e) return;
    
        $e.style.scrollBehavior = "smooth"; // ✅ Smooth scrolling
    
        const items = $e.getElementsByTagName("div");
        if (items.length > 4) {
            const middleIndex = Math.floor((items.length - 4) / 2); // ✅ Find middle item index
            $e.scrollTop = (middleIndex + 1) * 43; // ✅ Adjust scroll position
        }
    };
    
    useEffect(() => {
        if (isPickerVisible) {
            setTimeout(() => {
                scrollToMiddle(htmlID + "-bd-r"); // ✅ Scroll months
                scrollToMiddle(htmlID + "-bd-l"); // ✅ Scroll years
            }, 50);
        }
    }, [isPickerVisible]);
    

    
    
    
    
    

    return (
        <div className="datepick25">
            <div className="datepick25-r">
                <Button type="primary" onClick={()=>{
                    onSearchClick && onSearchClick(year, month)
                }}>Tìm kiếm</Button>
            </div>
            <div className="datepick25-l" onClick={()=>{
                setIsPickerVisible(true)
            }}>
                <span>{month}</span> / <span>{year}</span>
            </div>
            <div className="datepick25-pop" style={{opacity:isPickerVisible?'100':'', pointerEvents:isPickerVisible?'auto':'', display:isPickerVisible?'block':'none'}}>
                <div className="bd">
                    <div className="bd2">
                        <div className="bd-r" id={htmlID+'-bd-r'}>
                            <div />
                            <div />
                            {lastFourMonths
                            .filter(item => item.year === parseInt(year)) // ✅ Only show months from the selected year
                            .map(item => (
                                <div key={item.month}  className={`month-item ${month == item.month ? "selected" : ""}`}>{item.month < 10 ? `0${item.month}` : item.month}</div>
                            ))}
                            <div />
                            <div />
                        </div>
                        <div className="bd-l" id={htmlID+'-bd-l'}>
                            <div />
                            <div />
                            {lastFourMonths
                                .map(_=>_.year)
                                .reduce((acc,cur)=>{ if(!acc.includes(cur)){acc.push(cur);} return acc; }, []) // unique
                                .map(yr => (
                                    <div
                                        key={yr}
                                        className={`year-item ${year == yr ? "selected" : ""}`}
                                    >
                                        {yr}
                                    </div>))}
                            <div />
                            <div />
                        </div>
                    </div>
                </div>
                <div className="ft">
                    <Button type="primary" onClick={()=>{
                        setIsPickerVisible(false)
                    }}>Xác nhận</Button>
                </div>
            </div>
        </div>
    );
};

export default Datepicker25;